<template>
  <div>
    <p class="title">Top 5 Destination Hospitals ({{ lastXDays }})</p>
    <table class="table table-sm">
      <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th class="count">Cases</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="[userName, twiageHospital, caseCount] in list" :key="userName">
          <td class="twiageHospital">
            <img
              v-if="twiageHospital"
              alt="This is a Twiage enabled hospital"
              src="../../assets/RedBird-FullOpacity.svg"
              title="This is a Twiage enabled hospital"
              width="20px"
            />
          </td>
          <td>{{ userName }}</td>
          <td class="count">{{ caseCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref, watch } from "vue";

const processData = ({ data, size }) => {
  return Object.entries(
    data
      .map(item => {
        return {
          hospitalName: item.destinationHospital ? item.destinationHospital.name : "N/A",
          twiageHospital: item.destinationHospital && !item.destinationHospital.nonTwiage
        };
      })
      .reduce((reduction, item) => {
        if (reduction[item.hospitalName] === undefined) {
          const { twiageHospital } = item;

          if (name === undefined) {
            reduction[item.hospitalName] = { count: 0, twiageHospital };
          }

          reduction[item.hospitalName] = { count: 0, twiageHospital };
        }

        reduction[item.hospitalName].count += 1;

        return reduction;
      }, {})
  )
    .sort((itemA, itemB) => {
      const [, { count: countA }] = itemA;
      const [, { count: countB }] = itemB;

      return countB - countA;
    })
    .slice(0, size)
    .map(([name, { count, twiageHospital }]) => [name, twiageHospital, count]);
};

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: ""
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    timespan: {
      type: String,
      default: "month"
    }
  },

  setup(props) {
    let list = ref(processData({ aggregateBy: props.aggregateBy, data: props.data, size: Number(props.size) }) || []);

    let lastXDays;

    if (props.isAdmin) {
      if (props.timespan === "month") {
        lastXDays = "Last 30 days";
      } else {
        lastXDays = "Last 7 days";
      }
    } else {
      lastXDays = "Last 5 days";
    }

    watch(
      () => props.data,
      newData => {
        list.value = processData({ aggregateBy: props.aggregateBy, data: newData, size: Number(props.size) });
      }
    );

    return {
      list,
      lastXDays
    };
  }
};
</script>

<style scoped>
.count {
  text-align: right;
  vertical-align: middle;
  width: 3rem;
}
.title {
  font-size: 1.2rem;
  letter-spacing: -0.25px;
}
.twiageHospital {
  vertical-align: middle;
}
</style>
